// src/hooks/countries/useForceDeleteAllCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllCountries } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useForceDeleteAllCountries = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAll,
        isPending: isForceDeletingAll,
    } = useMutation({
        mutationFn: forceDeleteAllCountries,
        onSuccess: (res) => {
            const message = res?.message || "Selected countries permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected countries");
        },
    });

    return {
        forceDeleteAllCountries: forceDeleteAll,
        isForceDeleteAll: isForceDeletingAll,
    };
};

export default useForceDeleteAllCountries;
